import { useDispatch, useSelector } from 'react-redux';
import { Switch } from '@mui/material';
import { featureFlags } from 'src/config/featureFlags';
import { selectApiVersion, setApiVersion } from 'src/infra/stores/reducer/apiVersionSlice';

export const ApiVersionSwitch = () => {
  const dispatch = useDispatch();
  const useV2 = useSelector(selectApiVersion);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setApiVersion(event.target.checked));
    window.location.reload();
  };

  if (!featureFlags.API_VERSION_SWITCH) {
    return null;
  }

  return (
    <div className='flex items-center justify-between p-8 bg-neutral-10 border border-neutral-20 rounded-8'>
      <div className='flex flex-col'>
        <p className='text-12 font-medium text-neutral-60 text-left'>API Version</p>
        <p className='text-12 xl:text-14 font-medium'>{useV2 ? 'v2' : 'v1'}</p>
      </div>
      <Switch checked={useV2} onChange={handleChange} color='primary' size='small' inputProps={{ 'aria-label': 'toggle API version' }} />
    </div>
  );
};
